import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';
import { Button } from '../../../components/ui/Button/Button';
import { FaFileAlt, FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Card = styled.div`
  background: white;
  border-radius: 20px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${colors.darkBlue};
  margin-bottom: 1.5rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
`;

const InfoBox = styled.div`
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e2e8f0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const InfoLabel = styled.span`
  font-weight: 500;
  color: #475569;
`;

const InfoValue = styled.span`
  color: #1e293b;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 500;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

/**
 * @param {Object} user - Dados do usuário autenticado
 */
const IniciarProtocolo = ({ user, oabData, tipoProtocolo, isInscrito, loading, onIniciar }) => {
  const navigate = useNavigate();

  const handleVoltarHome = () => {
    navigate('/');
  };

  return (
    <Card>
      <CardTitle>
        <FaFileAlt style={{ marginRight: '0.5rem', color: colors.lightBlue }} />
        Iniciar Protocolo Online
      </CardTitle>

      <InfoBox>
        <InfoRow>
          <InfoLabel>Nome do Solicitante:</InfoLabel>
          <InfoValue>{user.nome}</InfoValue>
        </InfoRow>
        <InfoRow>
          <InfoLabel>CPF:</InfoLabel>
          <InfoValue>{user.documento || 'Não informado'}</InfoValue>
        </InfoRow>
        {/* Dados da OAB só existem para usuários inscritos */}
        {isInscrito && (
          <>
            <InfoRow>
              <InfoLabel>OAB:</InfoLabel>
              <InfoValue>{oabData?.registroConselho || 'Não informado'}</InfoValue>
            </InfoRow>
            <InfoRow>
              <InfoLabel>Categoria:</InfoLabel>
              <InfoValue>{oabData?.tipoCategoria || 'Não informado'}</InfoValue>
            </InfoRow>
          </>
        )}
        <InfoRow>
          <InfoLabel>Tipo de Protocolo:</InfoLabel>
          <InfoValue>{tipoProtocolo}</InfoValue>
        </InfoRow>
      </InfoBox>

      <ButtonGroup>
        <Button
          variant="secondary"
          onClick={handleVoltarHome}
          leftIcon={<FaHome />}
        >
          Voltar para Home
        </Button>
        <Button
          variant="primary"
          size="large"
          onClick={onIniciar}
          disabled={loading}
          leftIcon={<FaFileAlt />}
        >
          {loading ? 'Criando...' : 'Iniciar Protocolo'}
        </Button>
      </ButtonGroup>
    </Card>
  );
};

export default IniciarProtocolo;
